import { ErrorMessage } from "formik"
import { Col, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import TextInput from "@/components/Inputs/TextInput"
import useFormErr from "@/hooks/useFormErr"
import type { AddStudentProject } from "@/types/projectTypes"

export default function ProjectsInputes() {
  const { t } = useTranslation()
  const { formErr } = useFormErr<AddStudentProject>()

  return (
    <Row>
      <Col md={6} className="mb-3">
        <TextInput
          label={t("newProjectModal.title")}
          placeholder={t("newProjectModal.title")}
          id="title"
          name="title"
          as="field"
          backError={formErr?.title}
          error={<ErrorMessage name="title" />}
        />
      </Col>
      <Col md={6} className="mb-3">
        <TextInput
          label={t("newProjectModal.description")}
          placeholder={t("newProjectModal.description")}
          id="description"
          name="description"
          as="field"
          backError={formErr?.description}
          error={<ErrorMessage name="description" />}
        />
      </Col>
      <Col md={6} className="mb-3">
        <TextInput
          label={t("newProjectModal.link")}
          placeholder={t("newProjectModal.link")}
          id="link"
          name="link"
          as="field"
          backError={formErr?.link}
          error={<ErrorMessage name="link" />}
        />
      </Col>
      <Col md={6} className="mb-3">
        <TextInput
          label={t("newProjectModal.videoLink")}
          placeholder={t("newProjectModal.videoLink")}
          id="video_link"
          name="video_link"
          as="field"
          backError={formErr?.video_link}
          error={<ErrorMessage name="video_link" />}
        />
      </Col>
    </Row>
  )
}
